// extracted by mini-css-extract-plugin
module.exports = {"BaseButton--disabled":"BaseButton_BaseButton--disabled_c9FDw"};